import { useQuery } from 'react-query';
import { TournamentAPI } from 'api/admin/tournament';
import { TOURNAMENTS } from 'helpers/constants';

export default function useTournaments() {
  return useQuery(TOURNAMENTS, TournamentAPI.fetchTournaments);
}
